import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { AddCertificatedOutletService } from "./add-certificated-outlet.service";
import Organization from "../../interfaces/organization";
import { FormControl } from "@angular/forms";
import { debounceTime, Subscription } from "rxjs";
import { DefaultSnackBarService } from "../../services/default-snack-bar.service";

@Component({
    selector: 'app-add-certificated-outlet',
    templateUrl: './add-certificated-outlet.component.html',
    styleUrls: ['./add-certificated-outlet.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddCertificatedOutletComponent {
  orgSearch = new FormControl<string|Organization|null>(null);
  searchSub: Subscription;
  valid = false;
  constructor(public dialogRef: MatDialogRef<AddCertificatedOutletComponent>, public addCertificatedOutletService: AddCertificatedOutletService, private _snackBar: DefaultSnackBarService) { }

  ngOnInit() {
    this.searchSub = this.orgSearch.valueChanges.pipe(debounceTime(500)).subscribe((searchVal)=> {
      if(typeof searchVal === "string"){
        this.addCertificatedOutletService.searchOrganizations(searchVal);
      }
      this.valid = !(typeof searchVal === "string" || searchVal === null);
    })
  }
  displayFn(org: Organization) {
    return org?.name ?? '';
  }
  save(){
    let sub:Subscription;
    if(this.orgSearch.value !== null && typeof this.orgSearch.value !== "string"){
      sub = this.addCertificatedOutletService.saveCertificatedOutlet(this.orgSearch.value).subscribe(({data}) => {
        this.dialogRef.close(data?.createCertificatedOutlet.id);
        this._snackBar.open('Created Certificated Outlet');
        sub?.unsubscribe();
      })
    }
  }
  ngOnDestroy() {
    this.searchSub?.unsubscribe();
  }
}
